import * as types from './mutation-type'
export const addElement = ({state, commit}, element) => {
  commit(types.ADD_ELEMENT, element)
}

export const deleteAllElements = ({state, commit}) => {
  commit(types.DELETE_ALL_ELEMENT)
}

export const selectedOneElement = ({state, commit}, index) => {
  commit(types.SELECTED_ONE_ELEMENT, index)
}
